import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Rejected library access for user',
  name: 'rejected_library_access',
  params: [
    {
      description: 'The id of the library',
      name: 'library_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The id of the updated library member',
      name: 'library_member_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
